import PropPagination from './index';

export default angular.module('edge.platform.widgets.propertiespagination', [])
    .component('gwPropertiesPagination', PropPagination);